import Button, { Archetypes as _Archetypes } from './Button';

export type Archetypes = _Archetypes;
export default Button;
